import { soft } from './softStyles';

// Small round markers used across the leaderboard: pick results, the winning
// score pick, and standings rank.

const dot = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: 1,
};

export const ResultDot = ({ correct }) => (
  <span
    style={{ ...dot, backgroundColor: correct ? soft.okBg : soft.missBg, color: correct ? soft.ok : soft.miss }}
    role="img"
    aria-label={correct ? 'Correct' : 'Missed'}
  >
    {correct ? '✓' : '✗'}
  </span>
);

export const WinPill = ({ children }) => (
  <span style={{
    display: 'inline-block',
    backgroundColor: soft.okBg,
    color: '#1E6B2A',
    borderRadius: '999px',
    padding: '3px 10px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  }}>
    {children}
  </span>
);

// Top three get faint gold / silver / bronze tints.
const podium = {
  1: { backgroundColor: '#FDF3D7', color: '#8A6100' },
  2: { backgroundColor: '#EEF0F3', color: '#4B5563' },
  3: { backgroundColor: '#F8E7DA', color: '#8A4B1C' },
};

export const RankBadge = ({ rank, tied }) => (
  <span
    style={{
      ...dot,
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: '#F1F3F5',
      color: '#4B5563',
      ...podium[rank],
    }}
    title={tied ? `Tied for ${rank}` : undefined}
  >
    {rank}
  </span>
);
